const ENABLED_CONCURRENT_CHANNEL_IDS = [1, 2, 7, 9, 10, 11, 12, 13]

export default ENABLED_CONCURRENT_CHANNEL_IDS
